// courses/course_A01.ts

export const course_A01 = `
  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">1. 현장 도착 전: "준비는 집에서부터 시작됩니다"</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>콜 타임(Call Time) 확인:</strong> 촬영 시작 전, 헤어/메이크업 샵 도착 시간과 현장 도착 시간을 엄격히 계산합니다. (교통 상황 변수 고려)</li>
      <li style="margin-bottom: 8px;"><strong>준비물 최종 점검:</strong> 당일 촬영분 대본, 현장 의상(스타일리스트와 협의), 배우 개인 상비약, 계절 용품(손난로, 휴대용 선풍기), 배우가 선호하는 간단한 간식과 음료를 챙깁니다.</li>
      <li><strong>차량 상태 체크:</strong> 장거리 이동이 많으므로 기름은 항상 여유 있게 채우고, 실내 청결 상태를 최상으로 유지합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">2. 현장 도착 직후: "인사가 업무의 시작입니다"</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>스태프 인사 및 현장 파악:</strong> 현장에 도착하면 가장 먼저 조감독(진행팀)에게 인사하고, 현재 촬영 진행 상황(앞 신이 밀렸는지 등)을 확인합니다.</li>
      <li style="margin-bottom: 8px;"><strong>대기 공간 확보:</strong> 배우가 편히 쉴 수 있는 대기실(혹은 대기 차량 위치)을 확인하고, 주변 소음이나 외부인 출입을 체크합니다.</li>
      <li><strong>의상 및 분장 준비:</strong> 의상팀, 분장팀과 소통하여 배우가 언제 옷을 갈아입고 분장을 시작해야 하는지 스케줄을 잡습니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">3. 촬영 진행 중: "배우의 눈과 귀가 되기"</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>모니터링:</strong> 카메라 뒤에서 배우의 연기를 모니터링하며, 대사가 틀리지는 않는지, 의상이나 머리 모양이 흐트러지지 않는지 세심히 살핍니다.</li>
      <li style="margin-bottom: 8px;"><strong>리허설 서포트:</strong> 리허설 시 배우의 동선을 함께 파악하고, 대본을 들고 대기하다가 필요할 때 바로 건네줍니다.</li>
      <li style="margin-bottom: 8px;"><strong>틈새 케어:</strong> 촬영이 잠시 멈추는 '세팅 시간'마다 배우에게 물을 건네거나, 추운 날엔 외투를 입혀주는 등 컨디션을 관리합니다.</li>
      <li><strong>현장 기록:</strong> 나중에 홍보용으로 활용할 수 있도록 현장 스틸 컷이나 비하인드 영상을 방해되지 않는 선에서 촬영해 둡니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">4. 촬영 종료 및 철수: "끝날 때까지 끝난 게 아닙니다"</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>소지품 및 의상 회수:</strong> 배우가 촬영을 마치면 현장에 두고 온 소지품이 없는지, 대본이나 개인 비품을 꼼꼼히 챙깁니다. (협찬 의상의 경우 오염이나 분실 주의)</li>
      <li style="margin-bottom: 8px;"><strong>스태프 감사 인사:</strong> "고생하셨습니다"라는 짧은 인사가 다음 현장에서의 배우 이미지를 결정합니다. 특히 감독님과 조감독님께 끝인사를 잊지 않습니다.</li>
      <li><strong>다음 스케줄 공유:</strong> 귀가하는 차 안에서 오늘 촬영의 피드백을 가볍게 나누고, 내일 혹은 다음 촬영의 콜 타임을 배우에게 다시 한번 숙지시킵니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">5. 왜 이 흐름을 익혀야 하는가?</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>현장의 효율성:</strong> 매니저가 흐름을 모르면 현장에서 우왕좌왕하게 되고, 이는 곧 배우의 집중력을 깨트리는 결과로 이어집니다.</li>
      <li><strong>사고 예방:</strong> 도착부터 철수까지의 루틴을 몸에 익히면, 중요한 소지품을 잃어버리거나 스케줄을 놓치는 실수를 방지할 수 있습니다.</li>
    </ul>
  </div>

  <div style="background-color: #f0f9ff; padding: 20px; border-radius: 12px; border-left: 5px solid #0284c7; margin-top: 30px;">
    <strong style="color: #0369a1; font-size: 1.1rem; display: block; margin-bottom: 10px;">💡 교육생을 위한 한 줄 요약</strong>
    <p style="margin: 0; color: #334155; font-style: italic; line-height: 1.6;">
      "배우 매니저의 시계는 배우보다 10분 빨리 가야 하고, 배우 매니저의 눈은 현장의 모든 스태프를 향해 있어야 합니다."
    </p>
  </div>
`;
